












































































































































import Vue from 'vue'
import mixins from 'vue-typed-mixins'

import { Process as ProcessType } from '@/store/workflow/types'
import AssessmentMixin from './AssessmentMixin'
import Measures from '@/survey/Measures.vue'
import Pcl5 from '@/survey/measures/pcl5/Pcl5.vue'
import Phq9 from '@/survey/measures/phq9/Phq9.vue'
import Process from '@/components/workflow/Process.vue'
import Task from '@/components/workflow/Task'
import Timer from '@/components/workflow/Timer.tsx'

export default mixins(AssessmentMixin).extend({
  components: {
    Measures,
    Pcl5,
    Phq9,
    Process,
    Task,
    Timer,
  },
  computed: {
    nextTimeOfMeasurement(): 'zw2wl' | 'zw3wl' | 'zw4wl' | 'postwl' | undefined {
      const currentCase: any = this.$store.getters.currentCase
      switch (this.timeOfMeasurement) {
        case 'zw1wl':
          return 'zw2wl'
        case 'zw2wl':
          return 'zw3wl'
        case 'zw3wl':
          if (currentCase.diagnosis === 'mde') {
            return 'zw4wl'
          } else {
            return 'postwl'
          }
        case 'zw4wl':
          return 'postwl'
        default:
          return undefined
      }
    },
  },
  inject: {
    process: {
      default: null,
    },
  },
  props: {
    inProcess: {
      type: Object as () => ProcessType,
      default(): ProcessType | null {
        return (this as any).process
      },
    },
    timeOfMeasurement: {
      type: String,
      required: true,
      validator(value: string) {
        const validValues = ['zw1wl', 'zw2wl', 'zw3wl', 'zw4wl']
        const isValid = validValues.indexOf(value) > -1
        if (isValid) {
          return true
        } else {
          console.error(`value is ${value}, but must be within [zw1wl, … zw4wl]`)
          return false
        }
      },
    },
  },
})
